import { computed } from 'vue';
import { useRoute, type RouteRecordName } from 'vue-router';

import { authRouteNamesArray } from '../auth0/auth.routes';

interface LoginActivityRoute {
  name: RouteRecordName | null | undefined;
  path: string;
}

const AUTH_ROUTE_PATHS = ['/auth', '/login', '/logout', '/signup'] as const;

const hasAuthPathPrefix = (path: string) => {
  return AUTH_ROUTE_PATHS.some((authPath) => {
    return path === authPath || path.startsWith(`${authPath}/`);
  });
};

export const isLoginActivityRoute = (route: LoginActivityRoute) => {
  const routeName = typeof route.name === 'string' ? route.name : null;

  if (routeName !== null && authRouteNamesArray.includes(routeName)) {
    return true;
  }

  return hasAuthPathPrefix(route.path);
};

export const useIsLoginActivityRoute = () => {
  const route = useRoute();

  return computed(() =>
    isLoginActivityRoute({
      name: route.name,
      path: route.path,
    }),
  );
};
